/**
 * Shared constants that can be used in both main and renderer processes
 * DO NOT put any process.env references here - it won't work in renderer!
 */

import { version } from '../package.json';

export const APP_VERSION = version;

export const BILLING_IPC_CHANNELS = {
  CREATE_CHECKOUT_SESSION: 'billing:createCheckoutSession',
  VERIFY_PAYMENT_SETUP: 'billing:verifyPaymentSetup',
} as const;

export const BILLING_TRIAL_PERIOD_DAYS = 30;

export const REPORTS_IPC_CHANNELS = {
  EXPORT_SALES_REPORT_PDF: 'reports:exportSalesReportPdf',
  EXPORT_REPORT_CSV: 'reports:exportReportCsv',
} as const;

export const ACCOMMODATION_DOC_IPC_CHANNELS = {
  EXPORT_BOOKING_CONFIRMATION_PDF: 'accommodation:exportBookingConfirmationPdf',
  EXPORT_CHECKIN_FORM_PDF: 'accommodation:exportCheckinFormPdf',
  EXPORT_CHECKOUT_FORM_PDF: 'accommodation:exportCheckoutFormPdf',
} as const;

export const TIMEZONES = Array.from(Intl.supportedValuesOf('timeZone'));
